import { HttpMethod } from 'app/utils/network';
import { API } from 'app/utils/request';

export const addTreatmnet = (treatmentRequest, authToken) => {
  const urlPath = '/treatment/addTreatment';
  const additionalHeader = {Authorization: `Bearer ${authToken}`}
  return API.request({
    method: HttpMethod.POST,
    urlPath: urlPath,
    body: treatmentRequest,
    additionalHeader: additionalHeader
  });
};

export const updateTreatmnet = (treatmentRequest, authToken) => {
  const urlPath = '/treatment/updateTreatment';
  const additionalHeader = {Authorization: `Bearer ${authToken}`}
  return API.request({
    method: HttpMethod.POST,
    urlPath: urlPath,
    body: treatmentRequest,
    additionalHeader: additionalHeader
  });
};

export const getTreatmnetById = (patientId, authToken) => {
  const urlPath = `/treatment/getTreatmentByRefPatientId/${patientId}`;
  const additionalHeader = {Authorization: `Bearer ${authToken}`}
  return API.request({
    method: HttpMethod.GET,
    urlPath: urlPath,
    additionalHeader: additionalHeader
  });
};

export const getTreatmentByRefDoctorId = (doctorId, authToken) => {
  const urlPath = `/treatment/getTreatmentByRefDoctorId/${doctorId}`;
  const additionalHeader = {Authorization: `Bearer ${authToken}`}
  return API.request({
    method: HttpMethod.GET,
    urlPath: urlPath,
    additionalHeader: additionalHeader
  });
};
export const getTreatmentByRefConsultantId = (refConsultantId, authToken) => {
  const urlPath = `/treatment/getTreatmentByRefConsultantId/${refConsultantId}`;
  const additionalHeader = {Authorization: `Bearer ${authToken}`}
  return API.request({
    method: HttpMethod.GET,
    urlPath: urlPath,
    additionalHeader: additionalHeader
  });
};

export const removeTreatmentById = (treatmentId, authToken) => {
  const urlPath = `/treatment/removeTreatment/${treatmentId}`;
  const additionalHeader = {Authorization: `Bearer ${authToken}`}
  return API.request({
    method: HttpMethod.DELETE,
    urlPath: urlPath,
    additionalHeader: additionalHeader
  });
};

export const removeTreatmentAndAccountById = (treatmentId, authToken) => {
  const urlPath = `/treatment/removeTreatmentAndAccount/${treatmentId}`;
  const additionalHeader = {Authorization: `Bearer ${authToken}`}
  return API.request({
    method: HttpMethod.DELETE,
    urlPath: urlPath,
    additionalHeader: additionalHeader
  });
};

export const getAllTreatmentDetails = (authToken) => {
  const urlPath = '/treatment/getAllTreatmentDetails';
  const additionalHeader = {Authorization: `Bearer ${authToken}`}
  return API.request({
    method: HttpMethod.GET,
    urlPath: urlPath,
    additionalHeader: additionalHeader
  });
};
